import { BaseSensor as Sensor } from './BaseSensor';
import { SensorSet } from './SensorSet';
import { TimeFrame } from './TimeFrame';
import { TimeFrameManager } from './TimeFrameManager';
import { Device } from './Device';
export class ZoneData extends Device{
	timeframeManagers: Map<string,TimeFrameManager>;
	
	sensors : SensorSet;	


	getTimeFrameManager(name):TimeFrameManager{
		return this.timeframeManagers.get(name);
	}

	timeframesNames : Array<string> = [ 'water','ventilation','circulation','cooling','heating','zweitarif','silentmode','zeitprogrammassistent'];
	getTimeFrameNames(){
		return this.timeframesNames;
	}
	constructor(_name:string,_id:number){
		super(_id);
 		this.timeframeManagers = new Map<string,TimeFrameManager>();
		// zonenunabhängig

		for(let name of this.timeframesNames){
			this.timeframeManagers.set(name,new TimeFrameManager());
		}
		this.timeframeManagers.get('silentmode').clear();
		this.name = _name;
		this.id = _id;
		this.values = new Map<string,string>();
		this.values.set('name',_name);
		this.values.set('heatingmode','ENUM_HEATING_MODE_TIMECONTROLLED');
		this.values.set('coolingmode','ENUM_COOLING_MODE_TIMECONTROLLED');
		this.values.set('zone_active','ENUM_ZONE_ENABLED_YES');
		this.values.set('zone_assignment','ENUM_ZONE_BINDING_CENTRAL_CONTROL');
		this.values.set('zone_valve','ENUM_ZONE_VALVE_STATUS_OPEN');
		this.values.set('warmwasserspeicher','ENUM_TYPE_OF_DHW_CIRCUIT_DHW');
		this.values.set('warmwasser_zirkulationspumpe','ENUM_STATUS_DHW_PUMP_ON');

		this.values.set('warmwasser_speicherladepumpe','ENUM_STATUS_DHW_PUMP_ON');
		this.values.set('warmwasser_legionellenschutz_tag','ENUM_ANTI_LEGIONELLA_DAY_OFF');
		this.values.set('warmwasser_speicher','Aktiv');
		this.values.set('warmwasser_parallele_speicherladung','ENUM_PARALLEL_CYL_CHARGING_NO');
		this.values.set('absence','off');
		this.values.set('quickset-temperature-enabled','off');
		this.scales.set("quickset-temperature-duration",Sensor.fromArgs("quickset-temperature-duration",3,0.5,12,0.5,"STD_UNIT_HOUR_NORMAL_LEFT"));
		this.scales.get('quickset-temperature-duration').registerHook('valueChanged',(value)=>{
			this.setValue('quickset-temperature-enabled',"on");
			let now = new Date();
			
			let then = new Date(now.getTime()+60*60*value*1000);
			this.dates.set('quickset-end-date',then);
		})
		this.dates = new Map<string,Date>();
		let firstOfYear = new Date();
		firstOfYear.setDate(1);
		firstOfYear.setMonth(0);
		firstOfYear.setHours(0);
		firstOfYear.setMinutes(0);
		this.dates.set("quickset-end-date",new Date(firstOfYear.getTime()));
		this.dates.set('absenceBegin',new Date(firstOfYear.getTime()));
		this.dates.set('absenceEnd',new Date(firstOfYear.getTime()));

		this.dates.set('cooling_days_begin',new Date(firstOfYear.getTime()));
		this.dates.set('cooling_days_end',new Date(firstOfYear.getTime()));
		let legionellenschutz_uhrzeit = new Date(firstOfYear.getTime());
		legionellenschutz_uhrzeit.setHours(4);
		legionellenschutz_uhrzeit.setMinutes(0);
		this.dates.set('legionellenschutz_uhrzeit',legionellenschutz_uhrzeit);
		this.name = _name;
		this.debug("got id "+this.id);
		this.sensors = new SensorSet();
		this.setupSensors();
		this.setupTimeFrameManagers()
	}

	isAbsentAt(date: Date) : boolean{
		return (date.getTime() > this.dates.get('absenceBegin').getTime() && date.getTime() < this.dates.get('absenceEnd').getTime());
	}
	isCoolingAt(date:Date) : boolean{
		return (date.getTime() > this.dates.get('cooling_days_begin').getTime() && date.getTime() < this.dates.get('cooling_days_end').getTime());	
	}

	getSensors(){
		return this.sensors;
	}

	setupTimeFrameManagers(){
		for(let name of this.timeframesNames){
			if(name == 'silentmode'){
				continue;
			}
			let timeFrameManager= this.timeframeManagers.get(name);
			//zd.timeframemanager = (timeFrameManager);
			for(let day=0;day<7;day++){
				let timeframe = new TimeFrame();
				let begin = new Date();
				begin.setHours(6);
				begin.setMinutes(0);
				let end = new Date();
				end.setHours(20);//default 20
				end.setMinutes(0);//default 00
				//console.log("Adding timeframemanager for "+name);
				timeFrameManager.addTimeFrameByArgs(day,begin,end,20,name,(name!='heating'));
	 		}
 		}
	}

	getSensor(type:string,name:string){
		return this.sensors.getSensor(type,name);
	}
	setupSensors(){
		//BaseSensor.fromArgs(name:string, currentValue: number, min:number,max: number, granularity:number, unit:string)
		//zonenunabhängig.
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("outdoor",-1,-100,100,0.5,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("water",55,35,70,0.1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("water_nominal",55,35,70,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.sensors.addTemperatureSensor(Sensor.fromArgs("water_inlet_nominal",0,0,70,0.1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.sensors.addTemperatureSensor(Sensor.fromArgs("water_hysterese_speicherladung",5.0,3,20,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.sensors.addTemperatureSensor(Sensor.fromArgs("water_speicherladung_offset",25,0,40,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.sensors.addMiscSensor(Sensor.fromArgs("water_max_speicherladezeit",60,20,120,1,"STD_UNIT_MINUTES_NORMAL_LEFT"));
		this.sensors.addMiscSensor(Sensor.fromArgs("water_sperrzeit_speicherladung",60,0,120,1,"STD_UNIT_MINUTES_NORMAL_LEFT"));
		// zonenspezifisch
		this.sensors.addPressureSensor(Sensor.fromArgs("water",1.2,0,3,0.1,"STD_UNIT_BAR_NORMAL_LEFT"));
	    this.sensors.addPressureSensor(Sensor.fromArgs("water_nominal",1.5,0,3,0.1,"STD_UNIT_BAR_NORMAL_LEFT"));


	    this.sensors.addTemperatureSensor(Sensor.fromArgs("correction_room",0,-3,3,0.5,"STD_UNIT_KELVIN_NORMAL_LEFT"));
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("correction_outside",0,-3,3,0.5,"STD_UNIT_KELVIN_NORMAL_LEFT"));
	    
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("room_temperature",20.5,-100,100,0.5,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("room_temperature_nominal",20.5,5,30,0.5,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("room_temperature_nominal_quick",20.5,5,30,0.5,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("room_temperature_reduced",15,5,30,0.5,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
	    this.sensors.addTemperatureSensor(Sensor.fromArgs("cooling_temperature_nominal",24,5,30,0.5,"STD_UNIT_CELSIUS_NORMAL_LEFT"));

		this.sensors.addVentilationSensor(Sensor.fromArgs("ventilation_normal",4,1,6,1,""));
	    this.sensors.addVentilationSensor(Sensor.fromArgs("ventilation_reduced",1,1,6,1,""));
	    
	    this.sensors.addHumiditySensor(Sensor.fromArgs("humidity",40,30,70,1,"STD_UNIT_PERCENT_RELATIVE_NORMAL_LEFT"));
	    this.sensors.addHumiditySensor(Sensor.fromArgs("humidity_nominal",40,30,70,1,"STD_UNIT_PERCENT_RELATIVE_NORMAL_LEFT"));

	    this.sensors.addAirQualitySensor(Sensor.fromArgs("airquality1",1051,800,1200,1,"STD_UNIT_PPM_NORMAL_LEFT"));
	    this.sensors.addAirQualitySensor(Sensor.fromArgs("airquality2",1001,800,1200,1,"STD_UNIT_PPM_NORMAL_LEFT"));
	    this.sensors.addAirQualitySensor(Sensor.fromArgs("airquality_nominal",1000,800,1200,100,"STD_UNIT_PPM_NORMAL_LEFT"));

	}



	_debug:boolean=false;
	debug(msg:string){
		if(this._debug){
			console.log("ZoneData("+this.getName()+"): "+msg);
		}
	}



}
